import { CompanySiteGuideVo, GetSupplierCapacityUsingGet1Params, SupplierCapacityVo } from '@servicesTypings/drpRequest'
import { drpRequest, openDrpRequest } from '@/utils/request'

interface UserCategoryType {
    label: string
    value: string
}

export interface DlzModelConfigJsonItem {
    jumpType: 'none' | 'outside' | 'inside' | 'goodDetail'
    userCategoryTree?: string[]
    userCategory?: UserCategoryType
    userCategoryId?: string
    spuId?: string
    bannerImageUrl?: string
    jumpUrl?: string
}

export interface DlzModelConfigJsonList {
    list: DlzModelConfigJsonItem[]
}
export type DlzModelConfigJsonType = DlzModelConfigJsonList | DlzModelConfigJsonItem | null
export interface DlzModelInfo {
    coId: string
    configJson: DlzModelConfigJsonType
    enabled: boolean
    id: string
    siteCode: string
    siteDomain: string
    siteLogo: string
}

export interface DlzModelCompanyContactInfo {
    address: {
        address: string
        rootAddress: string[]
    } | null
    coName: string
    phone: string
    weiXinNum: string
    contactQr: string
}

// 修改商家站点开关
interface updateSiteSwitchData {
    enabled: boolean
    siteCode?: string
}

export function updateSiteSwitch(data: updateSiteSwitchData): Promise<API.RootObject<boolean>> {
    return drpRequest.post('/companySiteConfig/updateSiteSwitch', {
        data,
    })
}

// 修改商家 修改配置
interface UpdateConfigData {
    configJson?: any
    siteLogo?: string
    siteCode: string
}
export function updateConfig(data: UpdateConfigData): Promise<API.RootObject> {
    return drpRequest.post('/companySiteConfig/updateSiteConfig', {
        data,
    })
}

// 获取商家站点配置
interface GetCompanySiteParams {
    inviteId?: string // 邀请用的
    siteDomain?: string // 独立站
    coId?: string // 寻合作 || 中台
    supplierId?: string // 这个应该是H5使用
}

export type SiteConfigResType = API.RootObject<DlzModelInfo>
export function openGetCompanySiteConfig(params: GetCompanySiteParams): Promise<SiteConfigResType> {
    return openDrpRequest.get('/open/companySiteConfig/getCompanySiteConfig', {
        params,
    })
}

export function getCompanySiteConfig(params): Promise<SiteConfigResType> {
    return drpRequest.get('/companySiteConfig/getCompanySiteConfig', { params })
}

export type ContactForCompanySiteRes = API.RootObject<DlzModelCompanyContactInfo>

// 获取联系方式(商家站点用)

interface GetContactForCompanySiteParams {
    siteDomain: string // 独立站
}
export function getContactForCompanySite(params: GetContactForCompanySiteParams): Promise<SiteConfigResType> {
    return drpRequest.get('/companySiteConfig/getContactForCompanySite', {
        params,
    })
}
// 获取品牌小站引导
/**
 * 获取品牌小站引导
 */
export function getCompanySiteGuideApi(): API.Res<CompanySiteGuideVo> {
    return drpRequest.get('/companySiteConfig/getCompanySiteGuide')
}

// 查询商家能力
/**
 * 查询商家能力
 */
export function getSupplierCapacity(params: GetSupplierCapacityUsingGet1Params): API.Res<SupplierCapacityVo> {
    return openDrpRequest.get('/open/supplier/getSupplierCapacity', { params })
}
